module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Silver.a0c843b3.png";